
import React from 'react';
import { RefreshCw } from 'lucide-react';

interface PullToRefreshIndicatorProps {
  isPulling: boolean;
  isRefreshing: boolean;
  pullDistance?: number;
  style?: React.CSSProperties;
  className?: string;
}

export function PullToRefreshIndicator({
  isPulling,
  isRefreshing,
  pullDistance = 0,
  style,
  className = ''
}: PullToRefreshIndicatorProps) {
  // Non mostrare nulla se non c'è interazione
  if (pullDistance <= 0 && !isRefreshing) {
    return null;
  }

  return (
    <div
      className={`w-full flex items-end justify-center overflow-hidden ${className}`}
      style={style}
    >
      <div className="flex flex-col items-center justify-center pb-2">
        <div className={`p-2 rounded-full bg-black/60 backdrop-blur-sm border border-white/20 ${
          isRefreshing ? 'animate-spin' : ''
        }`}>
          <RefreshCw 
            className={`w-5 h-5 text-white transition-transform duration-200 ${
              isPulling && !isRefreshing ? 'rotate-180' : ''
            }`} 
          />
        </div>
        <div className="mt-1 text-xs text-white font-medium">
          {isRefreshing ? 'Aggiornamento...' : 
           pullDistance >= 80 ? 'Rilascia per aggiornare' : 
           'Trascina per aggiornare'}
        </div>
      </div>
    </div>
  );
}
